/**
 * Grupos e jogos da fase de grupos — Copa do Mundo 2026 (48 seleções, 12 grupos).
 * Elencos conforme sorteio (05/12/2025) e repescagens concluídas em março/2026:
 * - UEFA: República Tcheca, Bósnia, Turquia e Suécia (ESPN/ge, 31/03/2026)
 * - Intercontinental 1: RD Congo | Intercontinental 2: Iraque (FIFA/ESPN, 01/04/2026)
 * - Tabela de grupos: ge.globo.com (atualizado 18/05/2026)
 */

export type GrupoCopaId =
  | 'A' | 'B' | 'C' | 'D' | 'E' | 'F' | 'G' | 'H' | 'I' | 'J' | 'K' | 'L';

export type RodadaGrupo = 1 | 2 | 3;

export interface TimeCopa {
  id: string;
  nome: string;
}

export interface GrupoCopa {
  id: GrupoCopaId;
  times: TimeCopa[];
}

export interface JogoCopa {
  id: string;
  grupoId: GrupoCopaId;
  rodada: RodadaGrupo;
  mandanteId: string;
  visitanteId: string;
}

const t = (id: string, nome: string): TimeCopa => ({ id, nome });

export const GRUPOS_COPA_2026: GrupoCopa[] = [
  { id: 'A', times: [t('MEX', 'México'), t('RSA', 'África do Sul'), t('KOR', 'Coreia do Sul'), t('CZE', 'República Tcheca')] },
  { id: 'B', times: [t('CAN', 'Canadá'), t('BIH', 'Bósnia e Herzegovina'), t('QAT', 'Catar'), t('SUI', 'Suíça')] },
  { id: 'C', times: [t('BRA', 'Brasil'), t('MAR', 'Marrocos'), t('HAI', 'Haiti'), t('SCO', 'Escócia')] },
  { id: 'D', times: [t('USA', 'Estados Unidos'), t('PAR', 'Paraguai'), t('AUS', 'Austrália'), t('TUR', 'Turquia')] },
  { id: 'E', times: [t('GER', 'Alemanha'), t('CUW', 'Curaçao'), t('CIV', 'Costa do Marfim'), t('ECU', 'Equador')] },
  { id: 'F', times: [t('NED', 'Holanda'), t('JPN', 'Japão'), t('SWE', 'Suécia'), t('TUN', 'Tunísia')] },
  { id: 'G', times: [t('BEL', 'Bélgica'), t('EGY', 'Egito'), t('IRN', 'Irã'), t('NZL', 'Nova Zelândia')] },
  { id: 'H', times: [t('ESP', 'Espanha'), t('CPV', 'Cabo Verde'), t('KSA', 'Arábia Saudita'), t('URU', 'Uruguai')] },
  { id: 'I', times: [t('FRA', 'França'), t('SEN', 'Senegal'), t('IRQ', 'Iraque'), t('NOR', 'Noruega')] },
  { id: 'J', times: [t('ARG', 'Argentina'), t('ALG', 'Argélia'), t('AUT', 'Áustria'), t('JOR', 'Jordânia')] },
  { id: 'K', times: [t('POR', 'Portugal'), t('COD', 'República Democrática do Congo'), t('UZB', 'Uzbequistão'), t('COL', 'Colômbia')] },
  { id: 'L', times: [t('ENG', 'Inglaterra'), t('CRO', 'Croácia'), t('GHA', 'Gana'), t('PAN', 'Panamá')] },
];

/** Cronograma padrão FIFA (4 times): rodada 1: 0×1, 2×3 | rodada 2: 0×2, 1×3 | rodada 3: 0×3, 1×2 */
function jogosDoGrupo(grupo: GrupoCopa): JogoCopa[] {
  const [a, b, c, d] = grupo.times;
  const g = grupo.id;
  const mk = (rodada: RodadaGrupo, m: TimeCopa, v: TimeCopa, n: number): JogoCopa => ({
    id: `${g}-r${rodada}-${n}`,
    grupoId: g,
    rodada,
    mandanteId: m.id,
    visitanteId: v.id,
  });
  return [
    mk(1, a, b, 1),
    mk(1, c, d, 2),
    mk(2, a, c, 1),
    mk(2, b, d, 2),
    mk(3, a, d, 1),
    mk(3, b, c, 2),
  ];
}

export const JOGOS_COPA_2026: JogoCopa[] = GRUPOS_COPA_2026.flatMap(jogosDoGrupo);

export const timePorId = (() => {
  const map = new Map<string, TimeCopa>();
  GRUPOS_COPA_2026.forEach((g) => g.times.forEach((tm) => map.set(tm.id, tm)));
  return (id: string) => map.get(id);
})();

export function nomeTime(id: string): string {
  return timePorId(id)?.nome ?? id;
}

export function jogosDoGrupoId(grupoId: GrupoCopaId): JogoCopa[] {
  return JOGOS_COPA_2026.filter((j) => j.grupoId === grupoId);
}
